module.exports = __webpack_public_path__ + "img/alert.9bbf33cd.svg";